module.exports = __webpack_public_path__ + "img/f24561f.jpg";